module.exports = __webpack_public_path__ + "media/images/job-search-0bfa98610ef4533a5f85e9830a4e93c8.svg";